import AccessProfileService from "./accessProfileService";
import AdditionalInformationService from "./additionalInformation.service";
import AdvantageTypeService from "./advantageType.service";
import AgendaModel from "./agendaModel.service";
import { Anniversary } from "./anniversary.service";
import { Assignement } from "./assignement/assignement.service";
import { Formation } from "./assignement/formation.service";
import { Project } from "./assignement/project.service";
import { Task } from "./assignement/task.service";
import Bulles from "./bulles";
import CertificationFile from "./certificationFile.service";
import coefficientMultiplierService from "./coefficientMultiplier.service";
import Conge from "./conge.service.js";
import DataFile from "./dataFile.service";
import DataImage from "./dataImage.service";
import DayNotes from "./dayNotes.service";
import DayOff from "./dayOff.service";
import DisciplinaryService from "./disciplinary.service";
import DisciplinaryCategoryService from "./disciplinaryCategory.service";
import DisciplinaryGradationService from "./disciplinaryGradation.service";
import DocumentStorage from "./documentStorage.service";
import DocumentModelService from "./documentation/documentModel.service";
import DocumentationFileService from "./documentation/documentation-file.service";
import Documentation from "./documentation/documentation.service";
import Emplacement from "./emplacement.service.js";
import EmployerCertification from "./emploiCertification.service.js";
import EmployerCertificationFile from "./emploiCertificationFile.service";
import EmployerCourse from "./emploiCourse.service.js";
import EmployerFormation from "./emploiFormation.service";
import EmployerNote from "./emploiNote.service.js";
import EmployerSalary from "./emploiSalaire.service.js";
import employeeStatusService from "./employeeStatus.service";
import EmployerAssignment from "./employerAssignment.js";
import EmployerDocument from "./employerDocument.service.js";
import EmployerEmplacement from "./employerEmplacement.service";
import EmployerGroup from "./employerGroup.service.js";
import EmployerHours from "./employerHours.service";
import Employer from "./employers.service.js";
import EmployeurDService from "./employeurD/employeurD.service";
import Enterprise from "./entreprise.service.js";
import Accounts from "./expenses/accounts";
import Category from "./expenses/category";
import Distance from "./expenses/distance";
import Itinerary from "./expenses/itinerary";
import Reimbursement from "./expenses/reimbursement";
import Taxes from "./expenses/taxes";
import ExternalLinkService from "./externalLink.service";
import GenderTypeService from "./genderType.service";
import Groupe from "./groupe.service.js";
import HolidayNameService from "./holidayName.service";
import HolidaySoldeService from "./holidaySolde.service";
import HoraireService from "./horaire.service";
import LockedDayService from "./lockedDay.service";
import Material from "./material.service";
//import Mail from "./mail.service.js";
import News from "./news.service.js";
import NewsFile from "./newsFile.service.js";
import NotificationPushService from "./notification-push.service";
import Notification from "./notification.service";
import CoverageTypeService from "./onboarding/coverageType.service";
import EventUnavalaibilityService from "./onboarding/eventUnavalaibility.service";
import InsurancePlanNumberService from "./onboarding/insurancePlanNumber.service";
import OnboardingEmployeProtocol from "./onboarding/onboardingEmployeProtocol.service";
import OnboardingEmployeTask from "./onboarding/onboardingEmployeTask.service";
import OnboardingProtocol from "./onboarding/onboardingProtocol.service";
import OnboardingTask from "./onboarding/onboardingTask.service";
import TypeDemissionService from "./onboarding/typeDemission.service";
import TypeUnaivalabilityService from "./onboarding/typeunaivalability.service";
import UnavailabilityService from "./onboarding/unavailability.service";
import UnavailabilityBodyLocationService from "./onboarding/unavailabilityBodyLocation.service";
import UnavailabilityGravityService from "./onboarding/unavailabilityGravity.service";
import UnavailabilityInjuryNatureService from "./onboarding/unavailabilityInjuryNature.service";
import UnavailabilityMainCauseService from "./onboarding/unavailabilityMainCause.service";
import UnavailabilityPlaceService from "./onboarding/unavailabilityPlace.service";
import Password from "./password.service";
import Permission from "./permission.service.js";
import PinServices from "./pin.service";
import Poste from "./poste.service.js";
import PrimesServices from "./primes/primes.services";
import SalaryAndAdvantage from "./salaryAndAdvantage.service";
import SalaryTemplateService from "./salaryTemplate.service";
import statusService from "./status.service";
import SubGroup from "./subGroup.service.js";
import TimeBankService from "./timeBank.service";
import TimeBankSettingService from "./timeBankSetting.service";
import TimeClockLimitService from "./timeClockLimit.service";
import TimeClock from "./timeclock.service";
import Traduction from "./traductions.service.js";
import Upload from "./upload.service.js";
import UserSetting from "./userSetting.service";
import Users from "./users.service.js";
import WorkedHoursTypes from "./workedHoursTypes.service";
import WorkedHoursTypesAutoAdjustSettingService from "./workedHoursTypesAutoAdjustSetting.service";
import WorkingHours from "./workingHours.service";
import WorkingHoursFlag from "./workingHoursFlag.service";

export * from "./evaluation";
export * from "./developmentPlan";
export * from "./survey";

export * from "./organisator";

export {
  NotificationPushService,
  Emplacement,
  EmployerCertification,
  EmployerFormation,
  EmployerCourse,
  SalaryAndAdvantage,
  AdvantageTypeService,
  GenderTypeService,
  EmployerNote,
  EmployerSalary,
  SalaryTemplateService,
  EmployerDocument,
  EmployerGroup,
  EmployerEmplacement,
  EmployerHours,
  Employer,
  Conge,
  AgendaModel,
  // Mail,
  News,
  NewsFile,
  Permission,
  Poste,
  SubGroup,
  Traduction,
  Upload,
  Users,
  Groupe,
  Enterprise,
  Password,
  CertificationFile,
  EmployerCertificationFile,
  WorkingHours,
  DataImage,
  DataFile,
  TimeClock,
  DocumentStorage,
  HoraireService,
  Notification,
  Anniversary,
  Material,
  UserSetting,
  Assignement,
  Project,
  Task,
  EmployerAssignment,
  Formation,
  DayOff,
  Bulles,
  InsurancePlanNumberService,
  CoverageTypeService,
  TypeUnaivalabilityService,
  UnavailabilityPlaceService,
  UnavailabilityMainCauseService,
  UnavailabilityGravityService,
  UnavailabilityInjuryNatureService,
  UnavailabilityBodyLocationService,
  UnavailabilityService,
  OnboardingEmployeProtocol,
  OnboardingEmployeTask,
  OnboardingProtocol,
  OnboardingTask,
  Category,
  Reimbursement,
  Itinerary,
  Distance,
  Documentation,
  DocumentationFileService,
  DocumentModelService,
  Taxes,
  EmployeurDService,
  EventUnavalaibilityService,
  WorkedHoursTypes,
  WorkedHoursTypesAutoAdjustSettingService,
  WorkingHoursFlag,
  TypeDemissionService,
  DayNotes,
  HolidayNameService,
  HolidaySoldeService,
  TimeBankService,
  TimeBankSettingService,
  TimeClockLimitService,
  ExternalLinkService,
  LockedDayService,
  AccessProfileService,
  PrimesServices,
  coefficientMultiplierService,
  AdditionalInformationService,
  statusService,
  employeeStatusService,
  DisciplinaryCategoryService,
  DisciplinaryGradationService,
  DisciplinaryService,
  PinServices,
  Accounts
};
